// eslint-disable-next-line import/prefer-default-export
export const GET_FACTURA_ID = 'GET_FACTURA_ID';
export const UPDATE_FACTURA_ID = 'UPDATE_FACTURA_ID';